import { useMutation } from 'react-query';

import {
  useRequest,
  type MutationFunction,
  type MutationFunctionContext,
} from '@frontend/api';

type CopyPricingData = {
  isCopyingAddOns: boolean;
  isCopyingMaterials: boolean;
  isCopyingOperations: boolean;
  isCopyingPricingItems: boolean;
  isCopyingDiscounts: boolean;
  isCopyingQuantities: boolean;
  isCopyingProfitItems: boolean;
  componentIds: number[];
};

type CopyPricingVariables = {
  sourceComponentId: number;
  data: CopyPricingData;
};

const useCopyPricingKey = ['quotes', 'components', 'copyPricing'] as const;
export const getUseCopyPricingKey = () => useCopyPricingKey;

/**
 * Mutation function for copying pricing from one component to others.
 */
export const useCopyPricing: MutationFunction<void, CopyPricingVariables> = ({
  requestOptions,
  queryOptions,
} = {}) => {
  const request = useRequest(requestOptions);

  return useMutation<
    void,
    unknown,
    CopyPricingVariables,
    MutationFunctionContext<void>
  >(
    async ({ sourceComponentId, data }) => {
      await request(`/quotes/components/${sourceComponentId}/copy_pricing`, {
        init: {
          method: 'POST',
          body: data,
        },
      });
    },
    {
      ...queryOptions,
      mutationKey: getUseCopyPricingKey(),
    },
  );
};
